import { getListItemsInRange } from "./getListItemsInRange.js";
import { getParentListItem } from "./getParentListItem.js";
import { getPrevSibling } from "./getPrevSibling.js";
import { isCursorAtStartOfListItem } from "./isCursorAtStartOfListItem.js";
/**
 * Returns true when editor.deleteBackward() is safe to call (it won't break the structure).
 */
export function canDeleteBackward(editor) {
  var listItemsInSelection = getListItemsInRange(editor, editor.selection);
  if (listItemsInSelection.length === 0) {
    return true;
  }
  var [[, listItemPath]] = listItemsInSelection;
  var isInNestedList = getParentListItem(editor, listItemPath) !== null;
  var isFirstListItem = getPrevSibling(editor, listItemPath) === null;
  return isInNestedList || !isFirstListItem || !isCursorAtStartOfListItem(editor);
}